var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhyImg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 36,
    viewBox: "0 0 30 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "text-format",
    d: "M27.875,0H6.125A4.128,4.128,0,0,0,2,4.125v27.75A4.128,4.128,0,0,0,6.125,36h21.75A4.128,4.128,0,0,0,32,31.875V4.125A4.128,4.128,0,0,0,27.875,0ZM6.5,13.125A1.125,1.125,0,0,1,7.625,12h8.25A1.125,1.125,0,0,1,17,13.125v1.5a1.125,1.125,0,1,1-2.25,0V14.25H12.875v6a1.125,1.125,0,1,1,0,2.25h-2.25a1.125,1.125,0,1,1,0-2.25v-6H8.75v.375a1.125,1.125,0,1,1-2.25,0ZM26.375,31.5H7.625a1.125,1.125,0,0,1,0-2.25h18.75a1.125,1.125,0,0,1,0,2.25Zm0-4.5H7.625a1.125,1.125,0,0,1,0-2.25h18.75a1.125,1.125,0,0,1,0,2.25Zm0-4.5h-5.25a1.125,1.125,0,1,1,0-2.25h5.25a1.125,1.125,0,0,1,0,2.25Zm0-4.125h-5.25a1.125,1.125,0,1,1,0-2.25h5.25a1.125,1.125,0,0,1,0,2.25Zm0-4.125h-5.25a1.125,1.125,0,1,1,0-2.25h5.25a1.125,1.125,0,0,1,0,2.25Z",
    transform: "translate(-2)",
    fill: "#4397d2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyImg2);
export default __webpack_public_path__ + "static/media/whyImg2.e89a30498ddca820de2f28e12d7c192d.svg";
export { ForwardRef as ReactComponent };